<template>
    <span>
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar item"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <item-form
            :item="item"
            class="float-left"
            :mostrarModal="mostrarModal"
            operacao="A"
            @fecharModal="mostrarModal = false"
            @atualizarListaItens="$emit('atualizarListaItens', $event)"
        ></item-form>
    </span>
</template>

<script>
import BaseConhecimentoServicos from './BaseConhecimentoServicos'
import ItemForm from './ItemForm'

export default {
    components: {
        ItemForm
    },

    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        }
    }
}
</script>
